(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["jib1c0-announcement-bar"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('jib1c0-announcement-bar')) {
    class Jib1c0AnnouncementBar extends HTMLElement {
      constructor() {
        super();
        this.currentIndex = 0;
        this.rotateTimeout = null;
      }

      connectedCallback() {
        this.messages = this.querySelectorAll('.jib1c0-announcement-bar__message');
        this.track = this.querySelector('[data-ref="track"]');
        this.liveRegion = this.querySelector('[data-ref="live"]');
        this.reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
        if (!this.messages.length) return;

        /* Dismiss: check sessionStorage */
        if (this.dataset.dismissible !== undefined) {
          const sectionId = this.closest('.shopify-section')?.id || 'announcement';
          if (sessionStorage.getItem('jib1c0-announcement-dismissed-' + sectionId) === 'true') {
            this.classList.add('is-dismissed');
            return;
          }
        }

        /* Initialise slide state (no announce on first paint) */
        this.applyActiveState(false);

        /* Re-evaluate scroll-on-overflow when width / fonts change */
        if (this.dataset.overflow === 'scroll' && !this.reduceMotion && 'ResizeObserver' in window) {
          this._ro = new ResizeObserver(() => this.updateOverflow());
          this._ro.observe(this);
        }

        /* Arrow controls */
        const prevBtn = this.querySelector('[data-direction="prev"]');
        const nextBtn = this.querySelector('[data-direction="next"]');

        if (prevBtn) {
          prevBtn.addEventListener('click', () => this.navigate(-1));
        }
        if (nextBtn) {
          nextBtn.addEventListener('click', () => this.navigate(1));
        }

        /* Dismiss button */
        const dismissBtn = this.querySelector('.jib1c0-announcement-bar__dismiss');
        if (dismissBtn) {
          dismissBtn.addEventListener('click', () => this.dismiss());
        }

        /* Auto-rotate (skip under reduced motion — manual arrows still work) */
        if (this.dataset.autoRotate === 'true' && this.messages.length > 1 && !this.reduceMotion) {
          this.startAutoRotate();

          this.addEventListener('mouseenter', () => this.stopAutoRotate());
          this.addEventListener('mouseleave', () => this.startAutoRotate());
          this.addEventListener('focusin', () => this.stopAutoRotate());
          this.addEventListener('focusout', () => this.startAutoRotate());

          /* Pause when the tab is hidden (battery + INP friendly) */
          this._onVisibility = () => {
            if (document.hidden) {
              this.stopAutoRotate();
            } else {
              this.startAutoRotate();
            }
          };
          document.addEventListener('visibilitychange', this._onVisibility);
        }
      }

      disconnectedCallback() {
        this.stopAutoRotate();
        if (this._onVisibility) {
          document.removeEventListener('visibilitychange', this._onVisibility);
          this._onVisibility = null;
        }
        if (this._ro) {
          this._ro.disconnect();
          this._ro = null;
        }
      }

      navigate(direction) {
        this.currentIndex = (this.currentIndex + direction + this.messages.length) % this.messages.length;
        this.applyActiveState(true);
      }

      applyActiveState(announce) {
        for (let i = 0; i < this.messages.length; i++) {
          const message = this.messages[i];
          const active = i === this.currentIndex;
          message.classList.toggle('is-active', active);
          if (active) {
            message.removeAttribute('aria-hidden');
          } else {
            message.setAttribute('aria-hidden', 'true');
          }
          const link = message.querySelector('a');
          if (link) link.tabIndex = active ? 0 : -1;
        }
        if (this.track) {
          this.track.style.setProperty('--jib1c0-ab-index', this.currentIndex);
        }
        if (announce && this.liveRegion) {
          this.liveRegion.textContent = (this.currentIndex + 1) + ' / ' + this.messages.length;
        }
        this.updateOverflow();
      }

      /* Marquee the active message only if its text actually overflows */
      updateOverflow() {
        if (this.dataset.overflow !== 'scroll' || this.reduceMotion) return;
        const active = this.messages[this.currentIndex];
        if (!active) return;
        const textEl = active.querySelector('.jib1c0-announcement-bar__text');
        const inner = active.querySelector('.jib1c0-announcement-bar__text-inner');
        if (!textEl || !inner) return;
        /* Measure the clip container (nowrap): scrollWidth = full text, clientWidth = visible */
        const dist = textEl.scrollWidth - textEl.clientWidth;
        if (dist > 4) {
          const dur = Math.max(4, dist / 60);
          textEl.style.setProperty('--jib1c0-ab-scroll-dist', '-' + dist + 'px');
          textEl.style.setProperty('--jib1c0-ab-scroll-dur', dur + 's');
          textEl.classList.add('is-scrolling');
        } else {
          textEl.classList.remove('is-scrolling');
        }
      }

      startAutoRotate() {
        this.stopAutoRotate();
        this.scheduleNext();
      }

      /* Self-scheduling so a slide carrying a timer is held longer (readable) */
      scheduleNext() {
        const base = parseInt(this.dataset.rotateSpeed, 10) || 5;
        const active = this.messages[this.currentIndex];
        const hasTimer = active && active.querySelector('jib1c0-countdown');
        const delay = (hasTimer ? Math.max(base, 8) : base) * 1000;
        this.rotateTimeout = setTimeout(() => {
          this.navigate(1);
          this.scheduleNext();
        }, delay);
      }

      stopAutoRotate() {
        if (this.rotateTimeout) {
          clearTimeout(this.rotateTimeout);
          this.rotateTimeout = null;
        }
      }

      dismiss() {
        this.classList.add('is-dismissed');
        this.stopAutoRotate();
        const sectionId = this.closest('.shopify-section')?.id || 'announcement';
        try {
          sessionStorage.setItem('jib1c0-announcement-dismissed-' + sectionId, 'true');
        } catch (e) {
          /* sessionStorage may be unavailable — fail silently */
        }
      }
    }

    customElements.define('jib1c0-announcement-bar', Jib1c0AnnouncementBar);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["jib1c0-authority-grid"] && !Shopify.designMode) return;
  try {
    
  (function () {
    if (window.__jib1c0AuthorityRevealInit) return;
    window.__jib1c0AuthorityRevealInit = true;
    var run = function () {
      var els = document.querySelectorAll('[data-jib1c0-reveal]:not(.is-visible)');
      if (!els.length) return;
      if (!('IntersectionObserver' in window)) {
        els.forEach(function (el) { el.classList.add('is-visible'); });
        return;
      }
      var io = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) {
            var delay = parseInt(entry.target.getAttribute('data-jib1c0-reveal-delay') || '0', 10);
            setTimeout(function () { entry.target.classList.add('is-visible'); }, delay);
            io.unobserve(entry.target);
          }
        });
      }, { rootMargin: '0px 0px -10% 0px', threshold: 0.15 });
      els.forEach(function (el) { io.observe(el); });
    };
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', run);
    } else {
      run();
    }
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["jib1c0-icon-bar"] && !Shopify.designMode) return;
  try {
    
  // Les fleches et la barre d'avancement de `card_row`. Le defilement lui-meme
  // est natif (scroll-snap) : ce code ne fait que le commander et refleter ou
  // l'on en est. Garde idempotent — ce bloc est groupe pour tout le theme et
  // peut etre evalue plus d'une fois.
  (function () {
    if (window.__jib1c0IconBarWired) return;
    window.__jib1c0IconBarWired = true;

    function largeurDUnePas(piste) {
      var premier = piste.firstElementChild;
      return premier ? premier.getBoundingClientRect().width : piste.clientWidth;
    }

    function refletePosition(barre, piste) {
      var course = piste.scrollWidth - piste.clientWidth;
      var part = course > 0 ? piste.scrollLeft / course : 0;
      var n = piste.children.length || 1;
      var mini = 1 / n;
      barre.style.setProperty('--ib-progress', Math.max(mini, part) * 100 + '%');
    }

    function cabler(section) {
      // Garde PAR ELEMENT. Le garde global ne protege que ce fichier ; sans
      // celui-ci, chaque `shopify:section:load` rattache un jeu d'ecouteurs de
      // plus et la fleche avance de deux cartes, puis trois. Silencieux.
      if (section.dataset.ibWired) return;
      var piste = section.querySelector('[data-ib-piste]');
      var barre = section.querySelector('[data-ib-bar]');
      var prev = section.querySelector('[data-ib-prev]');
      var next = section.querySelector('[data-ib-next]');
      if (!piste || !barre || !prev || !next) return;
      section.dataset.ibWired = '1';

      function reflete() {
        var course = piste.scrollWidth - piste.clientWidth;
        // Le CSS prevoit un etat desactive ; sans ces deux lignes il n'etait
        // jamais pose, et la derniere fleche restait pleinement contrastee
        // tout en ne faisant rien.
        prev.disabled = piste.scrollLeft <= 1;
        next.disabled = piste.scrollLeft >= course - 1;
        refletePosition(barre, piste);
      }

      prev.addEventListener('click', function () {
        piste.scrollBy({ left: -largeurDUnePas(piste), behavior: mouvement() });
      });
      next.addEventListener('click', function () {
        piste.scrollBy({ left: largeurDUnePas(piste), behavior: mouvement() });
      });
      piste.addEventListener('scroll', reflete, { passive: true });
      reflete();
    }

    function mouvement() {
      return window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth';
    }

    function tout(e) {
      // Sur un rechargement de section, ne parcourir QUE cette section.
      var racine = e && e.target && e.target.querySelectorAll ? e.target : document;
      racine.querySelectorAll('.jib1c0-icon-bar[data-layout="card_row"]').forEach(cabler);
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', tout);
    } else {
      tout();
    }
    document.addEventListener('shopify:section:load', tout);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["jib1c0-product-recommendations"] && !Shopify.designMode) return;
  try {
    
  class Jib1c0ProductRecommendations extends HTMLElement {
    connectedCallback() {
      // burns merchant bandwidth on hover-prerendered PDPs that never activate.
      if (document.prerendering) {
        document.addEventListener('prerenderingchange', () => this.connectedCallback(), { once: true });
        return;
      }

      const url = this.dataset.url;
      if (!url) return;

      const observer = new IntersectionObserver((entries, obs) => {
        if (!entries[0].isIntersecting) return;
        obs.disconnect();
        this.loadRecommendations(url);
      }, { rootMargin: '200px' });

      observer.observe(this);
    }

    async loadRecommendations(url) {
      try {
        const response = await fetch(url);
        if (!response.ok) return;

        const html = await response.text();
        const doc = new DOMParser().parseFromString(html, 'text/html');
        const fresh = doc.querySelector('jib1c0-product-recommendations');

        if (fresh && fresh.innerHTML.trim().length > 0) {
          this.innerHTML = fresh.innerHTML;
        }
      } catch (error) {
        if (window.Shopify && window.Shopify.designMode) {
          console.error('Product recommendations failed:', error);
        }
      }
    }
  }

  if (!customElements.get('jib1c0-product-recommendations')) {
    customElements.define('jib1c0-product-recommendations', Jib1c0ProductRecommendations);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["jib1c0-sale-countdown-banner"] && !Shopify.designMode) return;
  try {
    
  (function () {
    if (window.__jib1c0SaleCountdownInit) return;
    window.__jib1c0SaleCountdownInit = true;
    function checkExpiry(section) {
      var iso = section.getAttribute('data-end-iso');
      if (!iso) return;
      var end = new Date(iso).getTime();
      if (!isFinite(end)) return;
      var now = Date.now();
      if (now >= end) {
        if (section.getAttribute('data-auto-hide') === 'true') {
          section.hidden = true;
          return;
        }
        var ended = section.querySelector('[data-ref="ended"]');
        var timer = section.querySelector('[data-ref="timer"]');
        if (ended) ended.hidden = false;
        if (timer) timer.hidden = true;
      }
    }
    function init() {
      var sections = document.querySelectorAll('.jib1c0-sale-countdown');
      sections.forEach(function (section) {
        checkExpiry(section);
        var iso = section.getAttribute('data-end-iso');
        if (!iso) return;
        var interval = setInterval(function () {
          checkExpiry(section);
          if (section.hidden) clearInterval(interval);
        }, 1000);
      });
    }
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', init, { once: true });
    } else {
      init();
    }
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["jib1c0-timeline"] && !Shopify.designMode) return;
  try {
    
  
  // rAF-throttled, passive listeners, idempotent guard.
  (function () {
    if (window.__jib1c0TimelineInit) return;
    window.__jib1c0TimelineInit = true;

    var sections = [];
    var ticking = false;

    function collect() {
      sections = Array.prototype.slice.call(document.querySelectorAll('.jib1c0-timeline'));
    }

    function update() {
      ticking = false;
      var winH = window.innerHeight;
      for (var i = 0; i < sections.length; i++) {
        var el = sections[i];
        var rect = el.getBoundingClientRect();
        // Progress 0 when section top hits 80% of viewport (just entered);
        // Progress 1 when section bottom hits 20% of viewport (almost gone).
        var startY = winH * 0.8;
        var endY = winH * 0.2;
        var p = (startY - rect.top) / (startY + rect.height - endY);
        if (p < 0) p = 0;
        if (p > 1) p = 1;
        el.style.setProperty('--jib1c0-tl-progress', p.toFixed(3));
      }
    }

    function onScroll() {
      if (ticking) return;
      ticking = true;
      requestAnimationFrame(update);
    }

    function init() {
      collect();
      update();
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', init);
    } else {
      init();
    }
    window.addEventListener('scroll', onScroll, { passive: true });
    window.addEventListener('resize', onScroll, { passive: true });
    document.addEventListener('shopify:section:load', collect);
    document.addEventListener('shopify:section:unload', collect);
  })();

  } catch(e) { console.error(e); }
})();
})();
